var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { space, fontSize, borderRadius, compose } from 'styled-system';
import themeGet from '@styled-system/theme-get';
import styledSystemPropTypes from '@styled-system/prop-types';
import { ChevronDown } from 'pcln-icons';
import { applySizes, borderRadiusAttrs, borders, deprecatedColorValue, getPaletteColor } from '../utils';
import { Flex } from '../Flex';
const sizes = {
    sm: css `
    padding: 6px 32px 7px 12px;
  `,
    md: css `
    padding: 10px 32px 11px 12px;
  `,
    lg: css `
    padding: 14px 32px 14px 12px;
  `,
    xl: css `
    padding: 18px 32px 19px 12px;
  `,
};
const ClickableIcon = styled(ChevronDown) `
  pointer-events: none;
`;
const propTypes = Object.assign(Object.assign(Object.assign({}, styledSystemPropTypes.space), styledSystemPropTypes.fontSize), { color: deprecatedColorValue() });
const SelectBase = styled.select.attrs(borderRadiusAttrs) `
  appearance: none;
  display: block;
  width: 100%;
  font-family: inherit;
  color: inherit;
  background-color: transparent;
  border-radius: ${themeGet('borderRadii.lg')};
  border-width: 1px;
  border-style: solid;

  ::-ms-expand {
    display: none;
  }

  &:disabled,
  &[readOnly] {
    background-color: ${getPaletteColor('background.light')};
    color: ${getPaletteColor('text.light')};
    cursor: not-allowed;
    opacity: 1;
  }

  ${({ theme }) => applySizes(sizes, undefined, theme.mediaQueries)};

  ${borders}

  ${(props) => compose(space, fontSize, borderRadius)(props)}
`;
SelectBase.defaultProps = {
    fontSize: [2, null, 1],
    m: 0,
    size: 'lg',
    borderRadius: 'lg',
};
SelectBase.propTypes = propTypes;
const Select = React.forwardRef((_a, ref) => {
    var { children, readOnly } = _a, props = __rest(_a, ["children", "readOnly"]);
    return (React.createElement(Flex, { width: 1, alignItems: 'center' },
        React.createElement(SelectBase, Object.assign({}, props, { readOnly: readOnly, ref: ref }), React.Children.map(children, (child) => {
            return React.cloneElement(child, {
                disabled: readOnly,
            });
        })),
        React.createElement(ClickableIcon, { ml: -32, color: 'text.light' })));
});
Select.displayName = 'Select';
Select.isField = true;
export default Select;
//# sourceMappingURL=Select.js.map